export default __webpack_public_path__ + "static/media/channel5.a5274c37.svg";